export const InvoiceAnalyticFields = {
    Description: 'description',
    Taxes: 'taxes',
    Quantity: 'qty',
    Image: 'image',
    Unit: 'unit',
    Price: 'price'
};

// ---- Mobile invoice test ID's ---

export const MobileInvoiceCogTestId = 'mobile-invoice-cog';
export const MobileInvoicePaymentScheduleBlockTestId =
    'mobile-invoice-payment-schedule-block';
export const MobileInvoicePaymentSchedulePriceTestId =
    'mobile-invoice-payment-schedule-price';

// view mode
export const MobileInvoiceViewServiceTitleTestId =
    'mobile-invoice-view-service-title';

// edit mode
export const MobileInvoiceEditServiceTitleTestId =
    'mobile-invoice-edit-service-title';
export const MobileInvoiceEditServiceTrashIconTestId =
    'mobile-invoice-edit-service-trash-icon';
export const MobileInvoiceEditServiceDescriptionTestId =
    'mobile-invoice-edit-service-description';
export const MobileInvoiceEditServiceQuantityTestId =
    'mobile-invoice-edit-service-quantity';
export const MobileInvoiceEditServiceUnitTestId =
    'mobile-invoice-edit-service-unit';
export const MobileInvoiceEditServiceTaxAppliedTestId =
    'mobile-invoice-edit-service-tax-applied';
export const MobileInvoiceEditServicePriceTestId =
    'mobile-invoice-edit-service-price';
export const MobileInvoiceEditServiceImageToggleTestId =
    'mobile-invoice-edit-service-image-toggle';
export const MobileInvoiceAddTaxTestId = 'mobile-invoice-add-tax';
export const MobileInvoiceAddDiscountTestId = 'mobile-invoice-add-discount';

export enum MobileContainerName {
    DisplaySetting = 'display-settings',
    Header = 'header',
    Summary = 'summary',
    ServiceSelection = 'service-selection',
    InvoiceContainer = 'invoice-container',
    PaymentSchedule = 'payment-schedule'
}
